<template>
  <div class="users">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" />
    <div class="filters">
      <div class="search">
        <div class="option" ref="marketplaceRef">
          <span>Marketplace</span>
          <artmisads-select
            style="width: 232px"
            v-model:value="filters.marketplace"
            :getPopupContainer="() => marketplaceRef"
            :options="COUNTRY_BASE_OPTIONS"
        />
        </div>
        
        <div class="option">
          <span>Date</span>
          <artemisads-range-picker
              v-model:value="dateParams"
              allowClear
              @openChange="openChange"
              style="width: 232px"
              :disabled-date="disabledDate"
              picker="month"
            />
        </div>
      </div>
      <div class="button">
        <artmisads-button isSquare="true" type="primary" style="margin-right: 8px;" :loading="load"
          @click="getPartData({})">Search</artmisads-button>
        <artmisads-button isSquare="true" @click="onReset">Reset</artmisads-button>
      </div>
    </div>
    <div class="export">
      <artmisads-button isSquare="true" type="primary" @click="exportData">Export</artmisads-button>
    </div>
    <div class="table-data">
      <artmisads-table v-model:pagination="pagination" :columns="columns" :data-source="data" :change="onTableChange"
        :loading="load" :scroll="{ x: 1600,y: 250 }">
        <template #bodyCell="{ column, text, index, record }">
          <div v-if="column.key !== 'action' && column.key !== 'user' && column.key !== 'billingDateTimestamp'">
            {{ text??'--' }}
          </div>
          <template v-if="column.key === 'user'">
            <div class="user">
              <div class="user-name">
                {{ record?.sellerName }}
              </div>
              <div class="user-email">{{ record?.sellerEmail }}</div>
            </div>
          </template>
          <template v-else-if="column.key === 'billingDateTimestamp'">
            <div>
              <!-- {{ AMAZON_COUNTRY_TIME_TZ[filters.marketplace] }} -->
              {{ moment(record?.billingDateTimestamp).tz(AMAZON_COUNTRY_TIME_AR[filters.marketplace]).format('YYYY-MM') }}
              <!-- {{ moment(record?.billingDateTimestamp).format('YYYY-MM') }} -->

            </div>
          </template>
         
        </template>
      </artmisads-table>
    </div>
  </div>
</template>

<script setup>
import moment from "moment";
import { message } from "ant-design-vue";
import { ref, reactive, onMounted } from "vue";
import { financeApi } from "~/server/operator/finance";
import breadcrumbs from "../../breadcrumbs.vue";
import { useRoute } from 'vue-router';
import { COUNTRY_BASE,AMAZON_COUNTRY_TIME_AR } from "~/contants/common";
// moment.format('YYYY-MM-DD')
const marketplaceRef = ref(null);
const COUNTRY_BASE_OPTIONS = COUNTRY_BASE.map((item) => {
  item.value = item.host;
  item.label = item.host;
  return item;
});
const dateParams = ref([moment().subtract(365, "day"), moment()]);
const breadcrumbsData = {
  title: "AR",
  des: "",
  links: [
    {
      name: "Home",
      path: "/operator/users",
    },
    {
      name: "Finance",
      path: "/operator/finance/payments",
    },
    {
      name: "AR",
      path: "/operator/finance/ar",
    },
  ],
};
const columns = [
  {
    title: "Date",
    key: "billingDateTimestamp",
    dataIndex: "billingDateTimestamp",
    align:'center'
  },
  {
    title: "Seller",
    key: "user",
    dataIndex: "user",
    align:'center'
  },
  {
    title: "Marketplace",
    dataIndex: "marketplace",
    key: "marketplace",
    align:'center'
  },
  {
    title: "Accum.Accrued Income",
    dataIndex: "accumAccruedIncome",
    key: "accumAccruedIncome",
    align:'center'
  },
  {
    title: "Accum.Received",
    dataIndex: "accumReceived",
    key: "accumReceived",
    align:'center'
  },
  {
    title: "Accounts Receivable(Accrued)",
    dataIndex: "ar",
    key: "ar",
    align:'center'
  },
  {
    title: "AR Aging Not Due",
    dataIndex: "arNotDue",
    key: "arNotDue",
    align:'center'
  },
  {
    title: "AR Aging 1-30 Days",
    dataIndex: "ar1To30Days",
    key: "ar1To30Days",
    align:'center'
  },
  {
    title: "AR Aging 31-60 Days",
    dataIndex: "ar31To60Days",
    key: "ar31To60Days",
    align:'center'
  },
  {
    title: "AR Aging 60 Days+",
    dataIndex: "arOver60Days",
    key: "arOver60Days",
    align:'center'
  },
  {
    title: "BD",
    dataIndex: "bd",
    key: "bd",
    align:'center',

  },
 
];
const filters = reactive({
  marketplace: 'amazon.com',
  startBillingDateStr:`${dateParams.value[0].format('YYYY-MM')}-01`,
  endBillingDateStr:`${dateParams.value[1].format('YYYY-MM')}-01`
});
const route = useRoute();
const sellerId = ref('');
const sellerName = ref('');
const data = ref([]);
const load = ref(true);
const pagination = reactive({
  current: 1,
  defaultPageSize: 10,
  size: 10,
  pageSize: 10,
  page: 1,
  total: 0,
  pageSizeOptions: ['10', '20', '50', '100'],
  showSizeChanger: true,
});
const onTableChange = ({ current, pageSize }) => {
  pagination.current = current;
  pagination.size = pageSize;
  pagination.pageSize = pageSize;
  getPartData({ page: current, size: pageSize });
};
const openChange = (status) => {
  if (!status && dateParams.value) {
    filters.startBillingDateStr = `${dateParams.value[0].format('YYYY-MM')}-01`;
    filters.endBillingDateStr = `${dateParams.value[1].format('YYYY-MM')}-01`;
  }
};
const init = () => {
  financeApi.getFinanceARagingReportSellerMonthly({ size: pagination.size,sellerId:sellerId.value,...filters }).then((res) => {
    data.value = res.data;
    pagination.total = res.total;
    load.value = false;
  });
};
const getPartData = (params) => {
  load.value = true;
  if(Object.keys(params).length === 0){
    pagination.current=1
  }
  let _params = {
    page: 1,
    size: pagination.size,
    marketplace: filters.marketplace,
    startBillingDateStr: filters.startBillingDateStr,
    endBillingDateStr: filters.endBillingDateStr,
    sellerId:sellerId.value
  };

  let newparams = { ..._params, ...params };
  newparams = Object.keys(newparams).reduce((acc, key) => {
    if (
      newparams[key] !== null &&
      newparams[key] !== undefined &&
      newparams[key] !== ""
    ) {
      acc[key] = newparams[key];
    }
    return acc;
  }, {});
  financeApi.getFinanceARagingReportSellerMonthly(newparams).then((res) => {
    if (res?.data) {
      if (params.size || params.page) {
        document.querySelector(".filters").scrollIntoView({
          behavior: "smooth",
        });
      }

      data.value = res.data;
      pagination.total = res.total;
      
    }
   else{
    message.error('Failure');
   }
   load.value = false;
  });
};
const onReset = () => {
  dateParams.value = [moment().subtract(365, "day"), moment()];
  filters.marketplace = 'amazon.com';
  filters.startBillingDateStr = `${dateParams.value[0].format('YYYY-MM')}-01`;
  filters.endBillingDateStr = `${dateParams.value[1].format('YYYY-MM')}-01`;
  pagination.current = 1;
  init();
}
const disabledDate = (current) => {
  if (!dateParams.value || dateParams.value.length === 0) {
    return false;
  }
  const tooLate =
    dateParams.value[0] && current.diff(dateParams.value[0], "days") > 365;
  const tooEarly =
    dateParams.value[1] && dateParams.value[1].diff(current, "days") > 365;
  return tooEarly || tooLate;
};



const exportData = () => {
  let params = {
    page: pagination.current,
    size: pagination.size,
    sellerId:sellerId.value,
    marketplace: filters.marketplace,
    startBillingDateStr: filters.startBillingDateStr,
    endBillingDateStr: filters.endBillingDateStr,
  };
  let time = moment().format("YYYY-MM-DD");
  const finalParams = {
    qs: params,
    fileName: `${sellerName.value}_${time}.csv`,
    platform: 'operator',
  };
  financeApi.sellerExportARagingReportSellerMonthly(finalParams);
};

onMounted(() => {
  sellerId.value = route.query?.sellerId;
  sellerName.value = route.query?.sellerName;
  filters.marketplace = route.query?.marketplace||'amazon.com';
  init();
});
</script>

<style lang="less" scoped>
.users {
  padding: 16px;
  padding-top: unset;
  width: 100%;
}

.filters {
  display: flex;
  justify-content: space-between;

  .search {
    display: flex;

    .option {
      >span {
        margin-right: 8px;
      }

      display: flex;
      align-items: center;
      margin-right: 24px;
    }
  }
}

.export {
  display: flex;
  justify-content: flex-end;
  margin: 16px 0;
}

.table-data {

  border-radius: 8px;
  border: 1px solid #fff;
  border-radius: 12px;
  overflow: hidden;
  border-radius: 12px;
  background-color: var(--color-white);
  padding: 15px;
  :deep(.ant-table) {
    border-radius: 8px 8px 0 0;
  }

  :deep(.ant-table-cell) {
    padding-left: 8px;
    padding-right: 8px;

    >a {
      color: var(--primary);

      &:hover {
        color: var(--primary-hover);
      }
    }
  }

  :deep(.ant-table-thead) {
    border-radius: 8px 8px 0 0;
  }

  .user {
    flex: 1;

    .user-name {
      color: var(--dark-1);
      font-weight: 500;
      font-size: 16px;
      letter-spacing: 0.4px;
      line-height: 20px;

      >span {
        font-weight: 400;
        margin-left: 4px;
      }
    }

    .user-email {
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-2);
      letter-spacing: 0.3px;
      line-height: 16px;
      padding: 10px 0;
    }

    .user-id {
      height: 16px;
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-3);
      letter-spacing: 0.3px;
      line-height: 16px;
    }
  }

}

.show-url {
  word-break: break-all;
}

.pending-amount {
  color: var(--red-1);
}

.actions {
  gap: 8px;
  display: flex;
}
</style>
